import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onfocus__queries-container q-text-dark" }
const _hoisted_2 = {
  key: 0,
  class: "onfocus__queries-content q-row"
}
const _hoisted_3 = {
  key: 1,
  class: "onfocus__queries-content q-row"
}

import QueriesHeader from "./QueriesHeader.vue";
import QueriesList from './QueriesList.vue'
import AccordionQueries from './AccordionQueries.vue'
import ClearQueriesButton from './ClearQueriesButton.vue'

import {useMobileViewStore} from "@/store/MobileViewStore";
import {storeToRefs} from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'QueriesContainer',
  props: ['queriesHeader', 'queries', 'canRemove'],
  setup(__props) {


const mobileViewStore = useMobileViewStore();




const {isMobileView} = storeToRefs(mobileViewStore)

// window.addEventListener('resize', mobileViewStore.updateIsMobileView);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isMobileView))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AccordionQueries, {
            "queries-header": __props.queriesHeader,
            queries: __props.queries,
            "can-remove": __props.canRemove
          }, null, 8, ["queries-header", "queries", "can-remove"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(QueriesHeader, { header: __props.queriesHeader }, null, 8, ["header"]),
          _createVNode(QueriesList, {
            queries: __props.queries,
            "can-remove": __props.canRemove
          }, null, 8, ["queries", "can-remove"]),
          (__props.canRemove)
            ? (_openBlock(), _createBlock(ClearQueriesButton, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})